import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UserSearch from '../../components/UserSearch';
import usersSlice from '../../store/users.store';

const UserSearchInput = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSetSearch = React.useCallback(
    (search: string) => {
      dispatch(usersSlice.actions.setSearch(search && search.length ? search : null));
      navigate({
        pathname: '/users',
        search: search && search.length ? `?search=${search}` : '',
      });
    },
    [dispatch, navigate]
  );
  const handleSubmit = React.useCallback(
    (search: string) => {
      handleSetSearch(search);
    },
    [handleSetSearch]
  );
  const handleReset = React.useCallback(() => {
    handleSetSearch('');
  }, [handleSetSearch]);
  return <UserSearch onSubmit={handleSubmit} onReset={handleReset} />;
};

export default UserSearchInput;
